import React, { useState } from "react";
import "./Category.scss";
import Logo from '../../img/Logo.svg'
import { FaAngleLeft } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
// import HomeCategory from '../../data/ChooesACategory.json'
import { useParams } from 'react-router-dom';
import CategoryWiseData from "../../layout/category/CategoryWiseData";
import RestaurantData from '../../data/MainJson'
// import Menu1 from "../../img/Menu-icon-1.png";
// import Menu2 from "../../img/Menu-icon-2.png";
// import Menu3 from "../../img/BreakFastIcons.png";
// import Menu4 from "../../img/Menu-icon-4.png";

import Menu1 from "../../img/Menu-icons-Group-1.png";
import Menu2 from "../../img/Dessert-outline.png";
import Menu3 from "../../img/Menu-icons-Group-3.png";
import Menu4 from "../../img/Menu-icons-Group-4.png";

import ActiveBreakFast from "../../img/Breakfast-fill.png";
import ActiveMeal from "../../img/Meal-fill.png";
import ActiveDrinks from "../../img/Drink-fill.png";
import ActiveDesserts from "../../img/desert-fill.png";

const Category = () => {
  const [CategoryData,setCategoryData] = useState(RestaurantData)
  const { name } = useParams();

  console.log(name)


  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1); // Navigate back to the previous page
  };


  const categoryWiseData = CategoryData && CategoryData.find((item) => item.Name === name)



  return (
    <div id="categoryPage">
      <div className="headerSections">
        <img width={97} src={Logo} alt="Cjs" />
        <div style={{paddingBottom:"1rem"}}></div>
        <div className="chooseCategory">
           <button onClick={handleGoBack} style={{position:"absolute",left:"10px",display:"flex",alignItems:"center",alignContent:"center",gap:"2px",backgroundColor:"transparent",border:"none"}}> 
              <span style={{paddingTop:"4px"}}><FaAngleLeft style={{color:"black"}}/></span>
              <span style={{textTransform:"inherit",fontSize:"12px",color:"black"}}>Go back</span>
            </button>
           <span style={{textTransform:"uppercase",fontWeight:"700"}}>{categoryWiseData && categoryWiseData.Name}</span>
        </div>
      </div>

     

    

      <div>
        <CategoryWiseData data ={categoryWiseData && categoryWiseData.type}/>
      </div>
      <div className="TabsMenu">
        <div className="MenuItems">
          <Link
            style={{ textDecoration: "none", color: "rgba(113, 128, 82, 1)" }}
            to={`/Category/Big On Breakfast`}
          >
            <div className={`items ${name === 'Big On Breakfast' ? 'activeMenu' : ''}`}>
            <img  width={40} src={name === 'Big On Breakfast' ? ActiveBreakFast : Menu4} alt="Big On Breakfast" />
              {name === 'Big On Breakfast' && (
                  <span>Breakfast</span>
              )}
             
            </div>
          </Link>

          <Link
            style={{ textDecoration: "none", color: "rgba(113, 128, 82, 1)" }}
            to={`/Category/Generous Big Meals`}
          >
            <div className={`items ${name === 'Generous Big Meals' ? 'activeMenu' : ''}`}>
            <img width={30} src={name === 'Generous Big Meals' ? ActiveMeal : Menu3} alt="Big Meals" />
              {name === 'Generous Big Meals' && (
                  <span>Big Meals</span>
              )}
            </div>
          </Link>
          <Link
            style={{ textDecoration: "none", color: "rgba(113, 128, 82, 1)" }}
            to={`/Category/Perfected Drinks`}
          >
            <div className={`items ${name === 'Perfected Drinks' ? 'activeMenu' : ''}`}>
            <img  width={22} src={name === 'Perfected Drinks' ? ActiveDrinks : Menu1} alt="Perfected Drinks" />
              {name === 'Perfected Drinks' && (
                  <span>Drinks</span>
              )}
            </div>
          </Link>
          <Link
            style={{ textDecoration: "none", color: "rgba(113, 128, 82, 1)" }}
            to={`/Category/Decadent Dessert`}
          >
            <div className={`items ${name === 'Decadent Dessert' ? 'activeMenu' : ''}`}>
            <img  width={30} src={name === 'Decadent Dessert' ? ActiveDesserts : Menu2} alt="Decadent Dessert" />
              {name === 'Decadent Dessert' && (
                  <span>Dessert</span>
              )}
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Category;
